window.addEventListener("load", function(){
    try{
        //#79
        document.querySelectorAll("add-to-cart > button").forEach((button)=>{
            // quick-view "add to cart" buttons
            addModalEventListeners(button);
        });
        document.querySelectorAll(".product-form__buttons > button.product-form__submit").forEach((button)=>{
            // single-product page "add to cart" button(s)
            addModalEventListeners(button);
        })

        function addModalEventListeners(button){
            button.addEventListener("click", ()=>{handleCartButtonClick(button)});
            button.addEventListener("keydown", (event)=>{
                if(event.key === "Enter"){ ()=>{handleCartButtonClick(button)}}
            });
            function handleCartButtonClick(button){
                button.setAttribute("adasc-modal-opener", true);
            }
        }

        const cartModal = document.querySelector("cart-drawer");
        const config = { attributes: true, childList: true, subtree: true };

        const handleModalFocus = (mutationList, observer) => {
            const details = cartModal.querySelector("details");
            if(details.className.includes("menu-opening")){
                cartModal.querySelector("drawer-close-button > .cart-close-btn").focus();
            } else if(details.className.includes("closing")){
                const openingElement = document.querySelector("[adasc-modal-opener=true]");
                if(openingElement){
                    openingElement.focus();
                    openingElement.removeAttribute("adasc-modal-opener");
                }

            }
        };

        const observer = new MutationObserver(handleModalFocus);
        observer.observe(cartModal, config);
    } catch(e){}
});

document.addEventListener("DOMContentLoaded", function() {
        // 
    try{
        let menuImgs = document.querySelectorAll('a.mega-menu__promo-link.media-wrapper img');

        if (menuImgs) {
            menuImgs.forEach(function (e) {
            e.setAttribute('alt', '');
            })
        }
    } catch(e){}

    // 
    try{
        let productcart = document.querySelectorAll('.product-grid .card-information');
        if (productcart.length > 0) {
            let i = 1;
            productcart.forEach(function (e) {
                let cartLink = e.querySelector('a.custom-cartlink');
                let cartBtn = e.querySelector('.button.custom-cartlink');
                
                if (cartLink) {
                    cartLink.setAttribute('id', 'cart' + i);
                    cartLink.addEventListener('focus', function (e) {
                        let allCartBtns = document.querySelectorAll('.button.custom-cartlink');
                        if (allCartBtns) {
                            allCartBtns.forEach(function (otherCartBtn) {
                              otherCartBtn.style.opacity = '0';
                            })
                        }
                    })
                }
                
                if (cartBtn && cartLink) {
                    let btn = cartBtn.querySelector('button');
                    if (btn) {
                        btn.setAttribute('aria-labelledby', 'cart' + i);
                    }
                    cartLink.addEventListener('focus', function (e) {
                        cartBtn.style.opacity = '1';
                        cartBtn.style.transform = 'translateY(0)';
                    })
                }
    
                i += 1;
            });
        }
    
        let hoverproducts = document.querySelectorAll('.card-wrapper');
        if (hoverproducts) {
            hoverproducts.forEach(function (e) {
                e.addEventListener('mouseover', function () {
                    let hoverprod = e.querySelector('.card-information__button .button');
                    if (hoverprod) {
                        hoverprod.style.opacity = '1';
                    }
                });
    
                e.addEventListener('mouseout', function () {
                    let hoverprod = e.querySelector('.card-information__button .button');
                    if (hoverprod) {
                        hoverprod.style.opacity = '0';
                    }
                });
            });
        }
    } catch(e){}

    // 
    try{
        let calform = document.querySelector('shipping-calculator form-state');

        if (calform) {
            let element = document.createElement('div');
            let textElement = document.createTextNode("All fields are required");
            element.style.textAlign = 'center';
            element.appendChild(textElement);
            calform.parentNode.insertBefore(element, calform);
        }
    } catch(e){}

    // 
    try{
        let searchLabel = document.querySelectorAll('form.search.search-modal__form > div > button.search__button.focus-inset[type="submit"]');

        if (searchLabel) {
            searchLabel.forEach(function (e) {
                e.ariaLabel = "Search";
            })
        }
    } catch(e){}

    // 
    try{
        let cartLink = document.querySelector('.cart-drawer-container .header__icon.focus-inset');

        if (cartLink) {
            function cartfocus() {
                let focusElement = document.querySelector('mini-cart#mini-cart');
                if (focusElement) {
                    focusElement.addEventListener('focus', function (e) {
                        console.log("e.this",e.this);
                        console.log("e.target",e.target);
                        e.target;
                    })
                }
            }
            
            cartLink.addEventListener('keydown', function (e) {
                if (e.keyCode == 13) {
                    setTimeout(() => {
                        cartfocus();
                    }, 100);
                }
            })
    
            cartLink.addEventListener('click', function (e) {
                setTimeout(() => {
                    cartfocus();
                }, 10);
            })
        }
    } catch(e){}

    try{ // #40
        const layoutSwitchers = document.querySelectorAll("layout-switcher");
        layoutSwitchers.forEach((switcher)=>{
            const buttons = switcher.querySelectorAll(".list-view__item");
            buttons.forEach((button)=>{
                if(button.className.includes("list-view__item--active")){
                    button.setAttribute("aria-label", button.getAttribute("aria-label") + " selected");
                }
                button.addEventListener("click", (event)=>{
                    clearSelected(buttons);
                    let ariaLabelText = button.getAttribute("aria-label");
                    ariaLabelText = ariaLabelText + " selected";
                    button.setAttribute("aria-label", ariaLabelText);
                })
            })
        });
        function clearSelected(buttons){
            buttons.forEach((button)=>{
                let prevAriaLabel = button.getAttribute("aria-label");
                if(prevAriaLabel.includes(" selected")){
                    prevAriaLabel = prevAriaLabel.replace(" selected", "");
                }
                button.setAttribute("aria-label", prevAriaLabel);
            });
        }
    } catch(e){}
    //
    try {
      setTimeout(() => {
        var payPalButton = document.querySelector('div.shopify-payment-button div[data-testid="PayPalInContext-button"]');  
        if (payPalButton) {
          payPalButton.setAttribute('role', 'link');
          payPalButton.setAttribute('aria-label', 'PayPal');
          payPalButton.setAttribute('aria-disabled', 'false');
          var disabledProductButton = document.querySelector('.product-form__buttons button[disabled="disabled"] + div.shopify-payment-button div[data-testid="PayPalInContext-button"]');
          if (disabledProductButton) {
              payPalButton.setAttribute('aria-disabled', 'true');
          }
          // document.querySelector('.product-form__buttons button[disabled="disabled"] + div.shopify-payment-button div[data-testid="PayPalInContext-button"]').setAttribute('aria-disabled', 'true');
        } 
      }, 5000);
    } catch (e) {}
    //
    try {
        document.querySelector('.cart-drawer').addEventListener('keydown', function(event) {
            const focusableElements = Array.from(this.querySelectorAll('input, button, a')).filter(el => el.offsetParent !== null);
            const firstElement = focusableElements[0];
            const lastElement = focusableElements[focusableElements.length - 1];      
            if (event.key === 'Tab') {
                if (event.shiftKey) {                  
                    if (document.activeElement === firstElement) {
                        lastElement.focus();
                        event.preventDefault();
                    }
                } else {                  
                    if (document.activeElement === lastElement) {
                        firstElement.focus();
                        event.preventDefault();
                    }
                }
            } 
        });

        function handleCartDrawerKeyboardNavigation(cartDrawer) {
            cartDrawer.addEventListener("keydown", function (event) {
                const focusableElements = Array.from(cartDrawer.querySelectorAll("input, button, a")).filter((el) => el.offsetParent !== null);
                const firstElement = focusableElements[0];
                const lastElement = focusableElements[focusableElements.length - 1];
        
                if (event.key === "Tab") {
                    if (event.shiftKey) {
                        if (document.activeElement === firstElement) {
                            lastElement.focus();
                            event.preventDefault();
                        }
                    } else {
                        if (document.activeElement === lastElement) {
                            firstElement.focus();
                            event.preventDefault();
                        }
                    }
                }
            });
        }
    
        document.querySelectorAll('add-to-cart button').forEach(button => {
            button.addEventListener("click", function () {
                setTimeout(() => {
                    const cartDrawer = document.querySelector(".cart-drawer");
                    if (cartDrawer) {
                        const firstFocusable = cartDrawer.querySelector("input, button, a");
                        if (firstFocusable) {
                            firstFocusable.focus();
                        }
                        handleCartDrawerKeyboardNavigation(cartDrawer);
                    }
                }, 5000); // Adjust this time delay as necessary
            });
        });

        document.querySelectorAll('button[name="add"]').forEach(button => {
            button.addEventListener("click", function () {
                setTimeout(() => {
                    const cartDrawer = document.querySelector(".cart-drawer");
                    if (cartDrawer) {
                        const firstFocusable = cartDrawer.querySelector("input, button, a");
                        if (firstFocusable) {
                            firstFocusable.focus();
                        }
                        handleCartDrawerKeyboardNavigation(cartDrawer);
                    }
                }, 2000); // Adjust this time delay as necessary
            });
        });
    } catch (e) {}

    try {
        document.querySelector('details.cart-drawer-container').addEventListener('click', function() {
          setTimeout(() => {
          const miniCartButton = document.querySelector('button.mini-cart__button');
          miniCartButton.addEventListener('click', function() {
            const miniCartContent = this.nextElementSibling;
            if (miniCartContent.hidden) {
              miniCartContent.hidden = false;
              miniCartContent.classList.add('open');
            } 
          });
          document.querySelector('button.cart-close').addEventListener('click', function() {
            const miniCartContent = this.closest('.mini-cart__content');
            miniCartContent.hidden = true;
            miniCartContent.classList.remove('open');
          });
          miniCartButton.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              this.click();
            }
          });
         }, 1000);
        });


    } catch (e) {}

    try {
      setTimeout(function() {
          var element = document.querySelector('div.flickity-page-dots');
          if (element) {              
              element.setAttribute('role', 'tabpanel');
          }
      }, 1000);
    } catch (e) {}
    
    try {
      var emailError = Array.from(document.querySelectorAll("p#ContactFooter-success")).filter(function(el) {
          return el.textContent.trim() === "Thanks for subscribing";
      });
      if (emailError.length > 0) {
          var successElement = document.querySelector("p#ContactFooter-success");
          if (successElement) {
              successElement.setAttribute("role", "status");
              successElement.setAttribute("aria-live", "polite");
          }
      }

    } catch (e) {}

    try {
      var button = document.querySelector(".select.shipping_btn button");
        if (button) {
            button.addEventListener('click', function() {
                setTimeout(function() {
                    var emailErrors = document.querySelectorAll(".field.form__message.errors .errors");
                    var emailError = Array.from(emailErrors).find(function(el) {
                        return el.textContent.trim() !== '';
                    });
                    
                    if (emailError) {
                        emailError.setAttribute("aria-describedby", "ShippingCalculatorZip");
                        button.focus();
                    }
                }, 2000);
            });
        }
    } catch (e) {}
    
    try {
        // #54
        function applyQuickViewFix(loopCount){
            if(loopCount < 10){
                const productGrids = document.querySelectorAll("ul.product-grid");
                if(productGrids.length > 0){
                    productGrids.forEach((productGrid, index)=>{
                        const products = productGrid.querySelectorAll("li.grid__item:not(.slider__slide)");
                        products.forEach((product, index2)=>{
                            product.querySelector(".card-information > a[href]").setAttribute("id", `product-link-${index+1}-${index2 + 1}`);
                            const quickViewButton = product.querySelector("#quick-view");
                            quickViewButton.setAttribute("id", `quick-view-${index+1}-${index2 + 1}`);
                            quickViewButton.setAttribute("aria-labelledby", `quick-view-${index+1}-${index2 + 1} product-link-${index+1}-${index2 + 1}`);
                        });
                    })
                } else {
                    setTimeout(()=>{
                        loopCount++;
                        applyQuickViewFix(loopCount);
                    }, 500);
                }
            }
        }
        let loopCount = 0;
        applyQuickViewFix(loopCount)
    } catch (e) {}

    try {
        document.addEventListener("keydown", function (event) {
    	  if (event.keyCode === 9 && event.target.matches("div.footer-block__details-content.footer-block-image a")) {
    	        event.preventDefault();
    	        var stickyCart = document.querySelector(".product-sticky-cart .sticky-cart.page-width");
    	        stickyCart.setAttribute("tabindex", "0");                
    	        stickyCart.focus();
                document.querySelector(".sticky-btn.header__icon--summary button").setAttribute("tabindex", "0");
                 document.querySelector(".product-sticky-cart .sticky-cart.page-width button").setAttribute("tabindex", "0");
    	    }
            if (event.key === "Tab" && event.target.matches(".sticky-btn.header__icon--summary button")) {
                event.preventDefault();
                var footerCopyrightButton = document.querySelector(".product-sticky-cart .sticky-cart.page-width button");
                if (footerCopyrightButton) {
                    if (event.shiftKey) {
                        footerCopyrightButton.focus();
                    } else {
                        footerCopyrightButton.focus();
                    }
                }
            }
        });
        var button = document.querySelector(".sticky-btn.header__icon--summary button");
        var stickyCartWrapper = document.querySelector(".sticky-cart-wrapper");
        function removeAnimateAttribute() {
            if (stickyCartWrapper) {
                stickyCartWrapper.removeAttribute("animate");
            }
            var footerCoptright = document.querySelector(".footer__copyright a");
              if (footerCoptright) {               
                  footerCoptright.focus();               
              }
        }
        button.addEventListener("click", removeAnimateAttribute);
        button.addEventListener("keydown", function(event) {
            if (event.key === "Enter") {
                removeAnimateAttribute();
            }
        });
    } catch (error) {}
});


document.addEventListener('DOMContentLoaded', function() {
    
    const menuItem = document.querySelector('a.header__menu-item.header__menu-item--top');
    const svgMarkup = `
      <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-caret" fill="none" viewBox="0 0 24 15">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M12 15c-.3 0-.6-.1-.8-.4l-11-13C-.2 1.2-.1.5.3.2c.4-.4 1.1-.3 1.4.1L12 12.5 22.2.4c.4-.4 1-.5 1.4-.1.4.4.5 1 .1 1.4l-11 13c-.1.2-.4.3-.7.3z" fill="currentColor"></path>
      </svg>
    `;    
    const svgElement = new DOMParser().parseFromString(svgMarkup, 'image/svg+xml').querySelector('svg');
    const spanLabel = menuItem.querySelector('span.label');
    spanLabel.insertAdjacentElement('afterend', svgElement);

    
    function wrapSvgWithButtonAndSetAriaLabel(svgSelector) {  
        document.querySelectorAll(svgSelector).forEach(svg => {
            const button = document.createElement('button');
            button.setAttribute('type', 'button');
            button.classList.add('svg-button');
            button.style.border = 'none';
            button.style.background = 'transparent';
            button.style.marginLeft = '5px';
            
            const svgClone = svg.cloneNode(true);
            svgClone.style.display = 'block';
            button.appendChild(svgClone);
            svg.parentNode.replaceChild(button, svg);
            
            const span = button.closest('a.header__menu-item.header__menu-item--top').querySelector('span');
            if (span) {
                button.setAttribute('aria-label', span.textContent.trim());
                button.setAttribute('aria-expanded', 'false');
            }
        });
    }
    wrapSvgWithButtonAndSetAriaLabel('a.header__menu-item.header__menu-item--top svg');
    
    document.body.addEventListener('keydown', function(e) {
        const target = e.target;        
        if (e.key === "Enter") {
            if (target.matches('nav.header__inline-menu > ul > li > dropdown-menu > a button')) {
                const isExpanded = target.getAttribute('aria-expanded') === 'true';
                target.setAttribute('aria-expanded', !isExpanded);
                target.closest('li').classList.toggle('is-focused-active', !isExpanded);
                e.preventDefault();
            } else if (target.matches('nav.header__inline-menu > ul > li > dropdown-menu > a.header__menu-item') && !target.querySelector('button')) {
                window.location.href = target.getAttribute('href');
            }            
        } else if (e.key === "Escape") {
            if (target.matches('nav.header__inline-menu > ul > li > dropdown-menu > a.header__menu-item + .list-menu-dropdown a')) {
                const parentDropdown = target.closest('.list-menu-dropdown').previousElementSibling;
                if (parentDropdown) {
                    parentDropdown.classList.remove('is-focused-active');
                    document.querySelectorAll('nav.header__inline-menu > ul > li').forEach(li => {
                        li.classList.remove('is-focused-active');
                        const button = parentDropdown.querySelector('button');
                        if (button) {
                            button.focus();
                            button.setAttribute('aria-expanded', 'false');
                        }
                    });
                }
              
            }
        }
        if (e.key === "Enter") {
          if (target.matches('nav.header__inline-menu > ul > li > mega-menu > a button')) {
            const isExpanded = target.getAttribute('aria-expanded') === 'true';
            target.setAttribute('aria-expanded', !isExpanded);
            target.closest('li').classList.toggle('is-focused-active', !isExpanded);            
            const megaMenu = target.closest('li').querySelector('mega-menu');
            if (megaMenu) {              
              const dropdownItems = megaMenu.querySelectorAll('.list-menu-dropdown .mega-menu__item, .list-menu-dropdown .mega-menu__promo');
              dropdownItems.forEach(item => {
                item.classList.toggle('show-from-bottom', !isExpanded);
              });
            }
            e.preventDefault();
          } else if (target.matches('nav.header__inline-menu > ul > li > mega-menu > a.header__menu-item') && !target.querySelector('button')) {
            window.location.href = target.getAttribute('href');
          }
        } else if (e.key === "Escape") {
          if (target.matches('nav.header__inline-menu > ul > li > mega-menu > a.header__menu-item + .list-menu-dropdown a')) {
            const parentDropdown = target.closest('.list-menu-dropdown');
            if (parentDropdown) {
              const parentMenuItem = parentDropdown.closest('li');
              if (parentMenuItem) {
                parentMenuItem.classList.remove('is-focused-active');                
                const megaMenu = parentMenuItem.querySelector('mega-menu');
                if (megaMenu) {
                  const button = megaMenu.querySelector('a button');
                  if (button) {
                    button.focus();
                    button.setAttribute('aria-expanded', 'false');
                  }
                }
              }
            }      
            document.querySelectorAll('nav.header__inline-menu > ul > li > mega-menu > a.header__menu-item').forEach(menuItem => {
              menuItem.classList.remove('is-focused-active');
            });
      
            e.preventDefault();
          }
        }
    });    
    document.body.addEventListener('keyup', function(e) {
        if (e.key === "Tab") {
            const target = e.target;
            if (target.matches('nav.header__inline-menu > ul > li > dropdown-menu > a.header__menu-item')) {
                target.classList.add('is-focused-active');
                document.querySelectorAll('nav.header__inline-menu > ul > li').forEach(sibling => {
                    if (sibling !== target.closest('li')) {
                        sibling.classList.remove('is-focused-active');
                        const button = sibling.querySelector('button');
                        if (button) {
                            button.setAttribute('aria-expanded', 'false');
                        }
                    }
                });
            }
        }
    });
    document.querySelector('nav.header__inline-menu > ul > li > dropdown-menu > a.header__menu-item + .list-menu-dropdown a[href="/pages/free-printables"]').addEventListener('keydown', function(event) {    
        if (event.key === "Tab") {
          let target = event.target;
          let siblings = document.querySelectorAll('nav.header__inline-menu > ul > li');
          siblings.forEach(function(sibling) {
            if (sibling !== target.closest('li')) {
              sibling.classList.remove('is-focused-active');
              let button = sibling.querySelector('button');
              if (button) {
                button.setAttribute('aria-expanded', 'false');
              }
            }
          });
        }
    });    
    function closeAllMenus() {
        const allMenus = document.querySelectorAll('nav.header__inline-menu > ul > li');
        allMenus.forEach(menu => {
            menu.classList.remove('is-focused-active');
            const button = menu.querySelector('button');
            if (button) {
                button.setAttribute('aria-expanded', 'false');
            }
        });
    }    
    document.querySelectorAll('nav.header__inline-menu > ul > li > dropdown-menu > a button, nav.header__inline-menu > ul > li > mega-menu > a button').forEach(button => {
        button.addEventListener('keydown', function(event) {
            if (event.key === "Escape") {
                closeAllMenus();
            }
        });
    });
    document.querySelectorAll("nav.header__inline-menu > ul > li > dropdown-menu > a , nav.header__inline-menu > ul > li > mega-menu > a").forEach(function(element) {
        element.addEventListener("keyup", function(event) {
            if (event.shiftKey) {
              closeAllMenus();
            }
        });
    });
});

